import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const usuarioCreateSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    primeiroNome: Yup.string().required(v.requiredField('primeiroNome')),
    sobreNome: Yup.string().required(v.requiredField('sobrenome')),
    email: Yup.string().email('E-mail inválido').required(v.requiredField('email')),
    cpf: Yup.string().test('cpf-ou-cns', t('usuario.cpf_ou_cns'), function (cpf) {
      return !!cpf?.trim() || !!this.parent.cns?.trim()
    }),
    cns: Yup.string(),
    telefone: Yup.string(),
    sexo: Yup.object().nullable().required(v.requiredField('sexo', 'select')),
    nascimento: Yup.string().required(v.requiredField('data_nascimento')),
    nomeGrupo: Yup.object().nullable().required(v.requiredField('grupo', 'select')),
  })
}
